export default "__VITE_ASSET__BNg1iicO__"